import React from "react";
import "containers/Checkout/CheckoutPaymentStatus/CheckoutPaymentStatus.css";
import Button from "components/Button/Button";
import { APP_ROUTES } from "constants/routes";
import { withRouter } from "react-router";

import { CrossIcon, SuccessIcon } from "constants/icons";

function CheckoutPaymentStatus({ failure = false, history }) {
  const componentTexts = window.appTexts.user_payment_page;

  const handleOrderAgain = function () {
    return history.push(APP_ROUTES.HOME_PAGE.url);
  };

  return (
    <div className="checkout-payment-status outer-shadow">
      <div className="checkout-payment-status__icon">
        {failure ? (
          <i className="checkout-payment-status__icon-failed">
            <CrossIcon />
          </i>
        ) : (
          <i className="checkout-payment-status__icon-success">
            <SuccessIcon />
          </i>
        )}
      </div>
      <div className="checkout-payment-status__message">
        {failure
          ? componentTexts.payment_failed_popup_title
          : componentTexts.payment_success_popup_title}
      </div>
      {failure ? (
        <div className="checkout-payment-status__action">
          <Button onClick={handleOrderAgain}>
            {componentTexts.payment_failed_popup_button_text}
          </Button>
        </div>
      ) : (
        <div className="loading-dots"></div>
      )}
    </div>
  );
}

export default withRouter(CheckoutPaymentStatus);
